import { SettingsBaseItem } from "../../dashboard/forms/improved_components/settings_items/settings_base_item";
import { RolesSearchDropdown } from "../../dashboard/forms/improved_components/roles_search_dropdown";
import Switch from "react-switch";
import { DashboardUtils } from "../../dashboard/dashboard_utils";

export const ELIGIBLE_ROLES_SETTINGS = {
	title: "Restrict Voting by Role",
	description:
		"Restrict which Discord roles can vote on this poll. Also restricts who can view the results on the dashboard.",
};

export function EligibleRolesSettingsItem(props: {
	selected_role_ids: string[];
	onRolesChange: (role_ids: string[]) => void;
	disabled?: boolean;
	is_enabled: boolean;
	onToggle: (enabled: boolean) => void;
	does_have_premium: boolean;
	is_public: boolean;
}) {
	const handleToggle = (checked: boolean) => {
		if (props.is_public) {
			// Show warning modal when trying to toggle with public visibility
			DashboardUtils.ShowDefaultErrorAlert(
				<div className="text-center">
					<p className="mb-2 font-bold text-red-400">
						This setting cannot be used when visibility is set to
						public.
					</p>
					<p>
						Please change the visibility to "Server Members" to
						enable role restrictions.
					</p>
				</div>,
				"Visibility Restriction"
			);
			return;
		}

		if (props.does_have_premium) {
			props.onToggle(checked);
			// Clear the role IDs if disabling the feature
			if (!checked) {
				props.onRolesChange([]);
			}
		}
	};

	return (
		<SettingsBaseItem
			label={ELIGIBLE_ROLES_SETTINGS.title}
			is_premium
			description={ELIGIBLE_ROLES_SETTINGS.description}
		>
			<div className="flex flex-col gap-4">
				<div className="flex items-center md:justify-end">
					<Switch
						checked={props.does_have_premium && props.is_enabled}
						onChange={handleToggle}
						disabled={props.disabled || !props.does_have_premium}
						onColor="#00c3cc"
						onHandleColor="#00f4ff"
						checkedIcon={
							<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
								<i className="fas fa-check"></i>
							</span>
						}
						uncheckedIcon={
							<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
								<i className="fas fa-times"></i>
							</span>
						}
					/>
				</div>
				{props.is_enabled &&
					props.does_have_premium &&
					!props.is_public && (
						<div className="w-full max-w-[256px]">
							<RolesSearchDropdown
								selected_ids={props.selected_role_ids}
								handleChange={props.onRolesChange}
								disabled={props.disabled}
								should_disable_managed_roles={true}
								should_disable_here={true}
								should_disable_everyone={true}
							/>
						</div>
					)}
			</div>
		</SettingsBaseItem>
	);
}
